import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./app/globals.css";

// Preload all 3D models immediately on app start (before React renders)
// This gives models a head start while React bootstraps
import { useGLTF } from "@react-three/drei";
useGLTF.preload("./models/caiLogoAnimated.glb");
useGLTF.preload("./models/arch/777massing.glb");
useGLTF.preload("./models/arch/SFO.glb");
useGLTF.preload("./models/arch/Nanning.glb");
useGLTF.preload("./models/arch/Lize.glb");
useGLTF.preload("./models/arch/Foshan.glb");
useGLTF.preload("./models/arch/SUNAC.glb");
useGLTF.preload("./models/arch/Belgrade.glb");
useGLTF.preload("./models/arch/XXGL.glb");
useGLTF.preload("./models/arch/SZShimao.glb");
useGLTF.preload("models/Arrow3D.glb");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
